exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-action[data-v-1db833c4]{display:flex;align-items:center;gap:14px;height:76px;padding:0 20px;border:1px solid var(--border);border-radius:var(--radius);background-color:#fff;text-align:left;cursor:pointer;transition:border-color .15s,box-shadow .15s,transform .15s}.dashboard-action[data-v-1db833c4]:focus,.dashboard-action[data-v-1db833c4]:hover{border-color:var(--lav-green);box-shadow:0 6px 16px rgba(16,24,40,.08);outline:none;transform:translateY(-1px)}.dashboard-action__icon[data-v-1db833c4]{display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:10px;background:var(--lav-green-soft);color:var(--lav-green-dark);font-size:20px}.dashboard-action__text[data-v-1db833c4]{font-size:15px;font-weight:600;color:var(--text)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1db833c4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard-action.vue
// module id = 546
// module chunks = 0